<template>
  <v-card>
    <v-card-title>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table class="row-pointer" :headers="actionHeader" :items="items" :search="search">
      <template slot="items" slot-scope="props">
        <tr>
          <td v-for="(header, index) in headers" :key="index">

            <!-- if it the actions column, then just show the pencil-->
            <div v-if="header.value === 'actions'">
              <div v-if="props.index !== editIndex">
                <v-icon @click="editItem(props)">edit</v-icon>
              </div>
              <div v-else>
                <v-icon @click="closeItem()">close</v-icon>
                <v-icon @click="saveItem()">save</v-icon>
              </div>
            </div>

            <!-- else show the data -->
            <div v-else>
              <!-- When editing this row, editable items are replaced with input fields -->
              <div v-if="props.index === editIndex && header.editable">
                <div v-if="header.type==='colour'">

                  <v-select v-model="editingItem[header.value]" class="pl-4" label="Colour" :items=colours>
                    <template v-slot:selection="{ item }">
                      <v-btn small :color="item" depressed icon>
                      </v-btn>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-btn small :color="item" depressed icon>
                      </v-btn>
                    </template>
                  </v-select>
                </div>

                <div v-if="header.type==='icon'">
                  <v-select v-model="editingItem[header.value]" class="pl-4" label="Icons" :items=icons>
                    <template v-slot:selection="{ item }">
                      <v-icon>
                        {{ item }}
                      </v-icon>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-icon>
                        {{ item }}
                      </v-icon>
                    </template>
                  </v-select>
                </div>

                <div v-else-if="header.type==='text'">
                  <v-text-field v-model="editingItem[header.value]"></v-text-field>
                </div>
              </div>

              <!-- Else they are shown as data -->
              <div v-else @click="clickTableRow(props.item)">
                <!-- if it is an icon -->
                <div v-if="header.type==='icon'">
                  <v-icon>{{genFieldIcon(props.item, header)}}</v-icon>
                </div>

                <!-- if it is text -->
                <div v-else-if="header.type==='text'">
                  {{ genFieldItem(props.item, header) }}
                </div>

                <!-- if it is text -->
                <div v-else-if="header.type==='colour'">
                  <v-btn small :color="genFieldIcon(props.item, header)" depressed icon>

                  </v-btn>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </template>
      <template></template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for <strong>"{{ search }}"</strong> found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex'
export default {
  name: 'GenericListTableV2',
  props: {
    parentID: {
      type: Number,
      default: null
    },
    title: {
      type: String
    },
    headers: {
      type: Array,
      default: null
    },
    url: {
      type: String
    },
    apiResponseField: {
      type: String
    },
    apiQueryParams: {
      type: String,
      default: null
    },
    onClickRoute: {
      type: String
    },
    onClickParams: {
      type: Function,
      default: null
    },
    onClickQuery: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      search: '',
      items: [],
      data: {},
      pageNo: 1,
      actionHeader: [],
      editIndex: -1,
      itemIndex: -1,
      editingItem: {},
      icons: [
        'local_drink',
        'water_damage',
        'water_drop',
        'whatshot',
        'network_check',
        'waves'
      ],
      colours: [
        'red',
        'pink',
        'purple',
        'deep-purple',
        'indigo',
        'blue',
        'light-blue',
        'cyan',
        'teal',
        'green',
        'light-green',
        'lime',
        'yellow',
        'amber',
        'orange',
        'deep orange',
        'brown',
        'blue-grey',
        'grey'
      ]
    }
  },
  async beforeMount () {
    // Copy headers so they can be changed
    this.actionHeader = this.headers
    // loop the headers
    // if any are editale, then we add the actions header
    for (const header of this.actionHeader) {
      if (header.hasOwnProperty('editable')) {
        this.actionHeader.push(
          { text: 'Actions', value: 'actions' }
        )
        break
      }
    }

    // Ensure all items have a type header
    for (const header of this.actionHeader) {
      if (!header.hasOwnProperty('type')) {
        header.type = 'text'
      }
    }

    const urlParams = {}
    if (this.parentID && this.parentID >= 0) {
      urlParams.parentid = this.parentID
    }
    try {
      var urlWithParams = this.url
      if (this.apiQueryParams != null) {
        urlWithParams = urlWithParams.concat(this.apiQueryParams)
      }
      const response = await this.$http.get(urlWithParams, {
        params: urlParams
      })
      this.items = response.data[this.apiResponseField]
      this.items = this.items.filter((value) => {
        return value.id > 0
      })

      /*
        (Matt H) Hack to fix this while keeping it generic

        This for project groups that have their button fields (Icon and Class) in a single field
        The item from the response eg for a "blue waves" for a given project group is
        {
            ...
            button: "{\"class\": \"success\", \"icon\": \"local_drink\"}"
            ...
        }

        In order for the fields to successfully update once saved on the table, which are treated as two
        seperate fields rather than one, this needs to get split into two fields called 'class' and 'icon'

        When the project group is passed as a prop to this component, this is reflected:

        { text: 'Icon', value: 'button.icon', editable: true, type: 'icon' },
        { text: 'Icon Colour', value: 'button.class', editable: true, type: 'colour' }
      soooo..
      */

      // Loops the header
      for (const header of this.headers) {
        // If it is editable and either an icon or colour type
        if (header.editable) {
          if (header.type === 'icon' || header.type === 'colour') {
            // Split the header value at '.' so we get eg ['button', 'icon'] or ['button', 'class']
            const fieldValues = header.value.split('.')
            //  Loop all the items (where items are what is rendered in the table)
            for (const item of this.items) {
              // Loop all the fields of the item
              for (const field in item) {
                // If the item matches the header value[0] eg 'button' in this case
                if (field === fieldValues[0]) {
                  // Then add a new field to the item
                  // Named button.class or button.icon
                  // and set it to the respective value

                  // Comments below show the example parsing a specific field

                  // EG "{\"class\": \"error\", \"icon\": \"whatshot\"}"
                  const itemValue = item[fieldValues[0]]

                  // EG {class: 'error', icon: 'whatshot'}
                  const parsedItemValue = JSON.parse(itemValue)

                  // EG class
                  const itemName = fieldValues[1]

                  // EG Error
                  const val = parsedItemValue[itemName]

                  item[header.value] = val
                }
              }
            }
          }
        }
      }
      // (Matt H) End hack
    } catch {
      this.failedGroupList()
    }
  },
  methods: {
    genFieldItem (item, header) {
      const fieldValues = header.value.split('.')
      if (fieldValues.length === 1) {
        return item[fieldValues[0]]
      } else if (fieldValues.length === 2) {
        // Gets nested values in the returned json data
        return item[fieldValues[0]][fieldValues[1]]
      }
    },

    genFieldIcon (item, header) {
      return item[header.value]
    },

    failedGroupList () {
      this.$emit(
        'error',
        `Failed to retrieve a list of ${this.title.toLowerCase()}.`
      )
    },
    getIndex (rowIndex, collumnIndex, headers) {
      var id = rowIndex.toString()
      var header = headers[collumnIndex].value

      return id + '%' + header
    },
    clickTableRow (item) {
      const params = this.onClickParams ? this.onClickParams(item) : {}
      const query = this.onClickQuery ? this.onClickQuery(item) : {}
      this.$router.push({
        name: this.onClickRoute,
        params: params,
        query: query
      })
    },
    editItem (prop) {
      // Reset editing item, give it the common id property
      this.editingItem = {}
      this.editingItem.id = prop.item.id

      for (const header of this.headers) {
        if (header.editable) {
          if (header.type === 'icon' || header.type === 'colour') {
            this.editingItem[header.value] = JSON.parse(
              prop.item[header.value.split('.')[0]]
            )[header.value.split('.')[1]]
          } else if (header.type === 'text') {
            this.editingItem[header.value] = prop.item[header.value]
          }
        }
      }

      for (const item of this.items) {
        if (item.id === prop.item.id) {
          this.itemIndex = this.items.indexOf(item)
        }
      }

      this.editIndex = prop.index
    },
    closeItem () {
      this.editIndex = -1
      this.itemIndex = -1
    },
    async saveItem () {
      let it = null
      for (const item in this.editingItem) {
        if (it === null) {
          it = this.items[this.itemIndex]
        }

        this.items[this.itemIndex][item] = this.editingItem[item]
        it = this.items[this.itemIndex]
      }

      this.editIndex = -1
      this.itemIndex = -1

      await this.$http.put(this.url, this.editingItem)
    }
  }
}

</script>

<style scoped>
.row-pointer tr :hover {
  cursor: pointer;
}
</style>
